import Cookies from "./cookie";
import store from "@saas/store/src";
import { EventBus } from "@saas/components/src/utils/event-bus";

const TokenKey = "accessToken";

export function getToken() {
  if (window.isElectron) {
    return localStorage.getItem("AuthToken");
  } else {
    return Cookies.getCookie(TokenKey);
  }
}

export function setToken(token, expires) {
  if (window.isElectron) {
    localStorage.setItem("AuthToken", token);
  }
  // const index = location.hostname.indexOf(".");
  // const domain = location.hostname.slice(index);
  const domain = getFirstLevelDomain(location.origin) || location.origin;
  return Cookies.setCookie(TokenKey, token, 30, domain);
}

export function removeToken() {
  if (window.isElectron) {
    localStorage.removeItem("AuthToken");
    // 清除vuex存储
    store.commit("classReminder/setLessonId", null);
    store.commit("classReminder/setLessonList", {});
    // 关闭除主窗口外的所有窗口
    if (window?.ipcRenderer) {
      window.ipcRenderer.send("user-logout");
    }
    if (store.getters.isAuthenticated) {
      EventBus.$emit("tim-logout");
    }
  }
  // const index = location.hostname.indexOf(".");
  // const domain = location.hostname.slice(index);
  const domain = getFirstLevelDomain(location.origin) || location.origin;
  return Cookies.delCookie(TokenKey, domain);
}

export function setRefreshToken(token) {
  localStorage.setItem("refreshToken", token);
}

export function getRefreshToken() {
  return localStorage.getItem("refreshToken");
}
export function removeRefreshToken() {
  localStorage.removeItem("refreshToken");
}

export function getOsInfo() {
  if (require && window.isElectron && !window.isWebPageInElectron) {
    const os = require("os");
    return {
      hostname: os.hostname(),
      platform: os.platform(),
      release: os.release(),
      userInfo: os.userInfo(),
      type: os.type(),
    };
  } else {
    return null;
  }
}

function getFirstLevelDomain(url) {
  try {
    // 创建URL对象
    const urlObj = new URL(url);
    // 获取主机名
    const hostname = urlObj.hostname;

    // 分割主机名
    const parts = hostname.split(".");
    // 检查是否有足够的部分来构成一级域名
    if (parts.length < 2) {
      throw new Error("Invalid domain format");
    }
    if (parts.length === 2) {
      return hostname;
    } else {
      // 获取一级域名
      const firstLevelDomain = parts.slice(-2).join(".");
      return firstLevelDomain;
    }
  } catch (e) {
    // 处理无效URL的情况
    console.error("Invalid URL:", e);
    return null;
  }
}
